import React, { useState } from 'react';
import { Timestamp, updateDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import { format } from 'date-fns';
import { HiOutlineCheckCircle, HiOutlineExclamationCircle } from 'react-icons/hi';
import { sendNotification } from '../../utils/sendNotification';

const TimelineEvent = ({ event }) => {
  const icon =
    event.color === 'green' ? <HiOutlineCheckCircle className="text-green-500 w-5 h-5 mr-1" /> :
    event.color === 'yellow' ? <HiOutlineExclamationCircle className="text-yellow-500 w-5 h-5 mr-1" /> :
    null;

  return (
    <div className="relative pl-6 border-l-2 border-gray-300 mb-6">
      <div
        className={`absolute -left-2 top-1 w-4 h-4 rounded-full ${
          event.color === 'green'
            ? 'bg-green-500'
            : event.color === 'blue'
            ? 'bg-blue-500'
            : event.color === 'yellow'
            ? 'bg-yellow-500'
            : 'bg-gray-400'
        }`}
      ></div>

      <div className="flex items-center gap-2">
        {icon}
        <h4 className="text-md font-semibold text-gray-800">{event.title}</h4>
      </div>

      <p className="text-sm text-gray-600">{event.description}</p>
      <p className="text-xs text-gray-400 mt-1">
        {format(event.timestamp.toDate(), 'PPPppp')}
      </p>
    </div>
  );
};

// ⬇️ Tu componente ClientTimeline queda tal cual lo escribiste
const ClientTimeline = ({ clientData, projectData, reloadClient }) => {

    const [showAdd, setShowAdd] = useState(false);
    const [newEvent, setNewEvent] = useState({
      title: "",
      description: "",
      color: "gray",
      timestamp: new Date(),
    });
  
    // Cambiamos esto: antes usabas clientData.projectTimeline
    const timeline = projectData?.projectTimeline || [];
  
    const sortedEvents = [...timeline].sort(
      (a, b) => b.timestamp?.seconds - a.timestamp?.seconds
    );
  
    const handleAddEvent = async () => {
        if (!clientData?.id || !projectData?.id) {
          console.warn("❌ Faltan IDs para actualizar el timeline");
          return;
        }
      
        const projectRef = doc(db, "clients", clientData.id, "projects", projectData.id);
      
        const updatedTimeline = [
          ...timeline,
          {
            ...newEvent,
            timestamp: Timestamp.fromDate(newEvent.timestamp),
          },
        ];
      
        await updateDoc(projectRef, { projectTimeline: updatedTimeline });
      
        const loginLink = `https://bbtspr.com/login`;
      
        const messageText = `${newEvent.title}\n\n${newEvent.description}\n\nPuedes ver el detalle aquí: ${loginLink}`;
        const clientName = clientData.name || "Cliente";
        const currentYear = new Date().getFullYear();
      
        const htmlBody = `
          <!DOCTYPE html>
          <html lang="es">
          <head>
            <meta charset="UTF-8">
            <title>Actualización de tu Proyecto - BBTS</title>
          </head>
          <body style="margin:0; padding:0; font-family:'Segoe UI', sans-serif; background-color:#f9fafb; color:#1f2937;">
            <div style="max-width:600px; margin:auto; background:#ffffff; padding:32px; border-radius:8px; box-shadow:0 0 12px rgba(0,0,0,0.05);">
              <div style="text-align:center; margin-bottom:24px;">
                <img src="https://bbtspr.com/favicon.ico" alt="BBTS Logo" style="width:60px; margin-bottom:8px;" />
                <h1 style="color:#1d4ed8; margin:0; font-size:22px;">¡Tenemos noticias sobre tu proyecto!</h1>
                <p style="margin-top:8px; font-size:15px; color:#4b5563;">Tecnología Inteligente para tu negocio</p>
              </div>
              <p style="font-size:16px; line-height:1.6;">Hola <strong>${clientName}</strong>,</p>
              <p style="font-size:16px; line-height:1.6;">
                Queríamos compartirte una actualización reciente sobre el progreso de tu proyecto. Estamos avanzando con entusiasmo y queremos que estés al tanto de cada paso.
              </p>
              <div style="background-color:#f3f4f6; padding:16px; border-radius:6px; margin:20px 0; font-size:15px; color:#374151;">
                ${messageText}
              </div>
              <p style="font-size:15px; line-height:1.6;">
                Si tienes alguna pregunta o deseas más detalles, no dudes en responder este correo. ¡Gracias por confiar en BBTS!
              </p>
              <p style="font-size:15px; margin-top:32px;">
                Saludos,<br />
                <strong>Equipo BBTS</strong>
              </p>
              <hr style="border:none; border-top:1px solid #e5e7eb; margin:32px 0;" />
              <div style="text-align:center; font-size:13px; color:#9ca3af;">
                BBTS &copy; ${currentYear} ·
                <a href="https://bbtspr.com" style="color:#3b82f6; text-decoration:none;">www.bbtspr.com</a>
              </div>
            </div>
          </body>
          </html>
        `;
      
        try {
          // 📧 Email
          if (clientData.email) {
            await sendNotification("email", {
              to: clientData.email,
              subject: "🕒 Actualización en tu proyecto",
              message: messageText,
              html: htmlBody,
            });
            console.log("✅ Notificación enviada por email.");
          } else {
            console.warn("⚠️ Cliente sin email, no se envía notificación por correo.");
          }
      
          // 📲 SMS
          const phone = clientData?.phone?.trim();
          const smsText = messageText?.trim();
      
          if (phone && smsText) {
            const formattedPhone = phone.startsWith('+') ? phone : `+1${phone}`;
      
            console.log("📨 Enviando SMS con:", {
              to: formattedPhone,
              message: smsText,
            });
      
            await sendNotification("sms", {
              to: formattedPhone,
              message: smsText,
            });
          } else {
            console.warn("⚠️ Cliente sin teléfono o mensaje, no se envía SMS.", {
              phone,
              smsText,
            });
          }
        } catch (error) {
          console.error("❌ Falló el envío de notificación:", error.message);
        }
      
        setShowAdd(false);
        setNewEvent({ title: "", description: "", color: "gray", timestamp: new Date() });
        reloadClient();
      };
      

  return (
    <div className="bg-white shadow rounded-lg p-6 mt-8">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-bold text-gray-800">🕒 Línea de Tiempo</h3>
        <button
          className="text-sm bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
          onClick={() => setShowAdd(true)}
        >
          ➕ Añadir Evento
        </button>
      </div>

      {sortedEvents.length === 0 ? (
        <p className="text-gray-500 text-sm">No hay eventos aún.</p>
      ) : (
        sortedEvents.map((event, idx) => <TimelineEvent key={idx} event={event} />)
      )}

      {/* Modal para añadir evento */}
      {showAdd && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md space-y-4 shadow">
            <h3 className="text-lg font-semibold">Nuevo Evento</h3>

            <div>
              <label className="block text-sm font-medium text-gray-700">Título</label>
              <input
                type="text"
                className="w-full border p-2 rounded text-sm"
                value={newEvent.title}
                onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Descripción</label>
              <textarea
                className="w-full border p-2 rounded text-sm"
                rows="3"
                value={newEvent.description}
                onChange={(e) => setNewEvent({ ...newEvent, description: e.target.value })}
              ></textarea>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Color</label>
              <select
                className="w-full border p-2 rounded text-sm"
                value={newEvent.color}
                onChange={(e) => setNewEvent({ ...newEvent, color: e.target.value })}
              >
                <option value="gray">Gris</option>
                <option value="blue">Azul</option>
                <option value="green">Verde</option>
                <option value="yellow">Amarillo</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Fecha y hora</label>
              <input
                type="datetime-local"
                className="w-full border p-2 rounded text-sm"
                value={new Date(newEvent.timestamp).toISOString().slice(0, 16)}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, timestamp: new Date(e.target.value) })
                }
              />
            </div>

            <div className="flex justify-end space-x-2 pt-4">
              <button onClick={() => setShowAdd(false)} className="bg-gray-300 px-4 py-2 rounded">
                Cancelar
              </button>
              <button
                onClick={handleAddEvent}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientTimeline;
